import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import {
  Heading,
  Panel,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
} from '@piggybank/core';

import { formatAccountWithMaskChar, formatAmount, formatDateObj, formatTimeObj } from '~/genericFunctions';
import { getSimpleKronerHeaderKey, NLS } from '~/pages/SuccessPage/successPageFunctions';

import { withAppContext } from '~/AppContext';

const SuccessCreditInformationPanel = ({ data }) => {
  let index = get(data, 'displayData.loanAmountIndex');
  let folio = get(data, 'displayData.folio');
  let depositAccount = get(data, 'displayData.loanOffer.depositAccount');
  let loanOptions = get(data, 'displayData.loanOffer.loanOptions');
  let currDateTime = new Date(Date.now());

  return (
    <Panel>
      <Heading level={2}>
        {NLS`${getSimpleKronerHeaderKey(data.displayData.globalData.offerId)}`}
      </Heading>
      <PlaybackList type="strong">
        <PlaybackKey>{NLS`Loan amount`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'principal.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Deposit account`}</PlaybackKey>
        <PlaybackValue>{formatAccountWithMaskChar(get(depositAccount, 'number'), '*')}</PlaybackValue>

        <PlaybackKey>{NLS`Commission fee`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.commission.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Value added tax`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.valueAddedTax.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Folio`}</PlaybackKey>
        <PlaybackValue>{folio}</PlaybackValue>

        <PlaybackKey>{NLS`Date`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(currDateTime)}</PlaybackValue>

        <PlaybackKey>{NLS`Time`}</PlaybackKey>
        <PlaybackValue marginBottom={0}>{formatTimeObj(currDateTime)}</PlaybackValue>
      </PlaybackList>
    </Panel>
  );
};

SuccessCreditInformationPanel.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      globalData: PropTypes.shape({
        offerId: PropTypes.string,
      }),
      loanOffer: PropTypes.shape({
        depositAccount: PropTypes.shape({
          number: PropTypes.string,
        }),
        loanOptions: PropTypes.arrayOf(PropTypes.shape()),
      }),
      folio: PropTypes.string,
      loanAmountIndex: PropTypes.number,
    }),
  }),
};

export default withAppContext()(SuccessCreditInformationPanel);
